export default "__VITE_ASSET__YEP8CAjm__"